export const FETCH_FOREX_PRODUCTS_REQUEST = 'FETCH_FOREX_PRODUCTS_REQUEST';
export const FETCH_FOREX_PRODUCTS_SUCCESS = 'FETCH_FOREX_PRODUCTS_SUCCESS';
export const FETCH_FOREX_PRODUCTS_FAILURE = 'FETCH_FOREX_PRODUCTS_FAILURE';
